import { type ReactNode, createContext, useContext, useEffect, useMemo } from 'react';
import { FormProvider } from 'react-hook-form';
import { OpenFormAsync } from './OpenFormAsync.js';
import { useOpenFormMethods } from './OpenFormHooks/useOpenFormMethods.js';
import { useRefReducer } from './OpenFormHooks/useRefReducer.js';
import { OpenFormReducer, type OpenFormState } from './OpenFormReducer.js';
import { OpenFormStore } from './OpenFormStore.js';

const OpenFormContextAsync = createContext(OpenFormAsync);
const OpenFormContextState = createContext({} as OpenFormState);

export const useOpenFormAsync = () => useContext(OpenFormContextAsync);
export const useOpenFormState = () => useContext(OpenFormContextState);

export const OpenFormProvider = ({ accountMasterId, children }: { accountMasterId?: string; children: ReactNode }) => {
  const store = useMemo(() => new OpenFormStore(sessionStorage, accountMasterId!), [accountMasterId]);
  const [state, dispatch] = useRefReducer(OpenFormReducer.reducer(store), OpenFormReducer.state());

  useEffect(() => {
    OpenFormAsync.actions = OpenFormReducer.actions(dispatch);
    OpenFormAsync.state = state;
    OpenFormAsync.store = store;
    OpenFormAsync.accountMasterId = accountMasterId;
    Object.assign(self, { async: OpenFormAsync });
    return () => {
      OpenFormAsync.cache.clear();
      OpenFormAsync.draft.clear();
      OpenFormAsync.forms.clear();
      Object.assign(self, { async: undefined });
    };
  }, [store, state, dispatch, accountMasterId]);

  return (
    <OpenFormContextState.Provider value={state.current}>
      <OpenFormContextAsync.Provider value={OpenFormAsync}>
        <FormProvider {...useOpenFormMethods(OpenFormAsync)}>{children}</FormProvider>
      </OpenFormContextAsync.Provider>
    </OpenFormContextState.Provider>
  );
};
